// https://github.com/vuejs/vuex/blob/dev/examples/shopping-cart/store/index.js

import moment from 'moment'
import Vue from 'vue'
import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import ENV from '../getEnv'
import newContract from './modules/new-contract'
import authentication from './modules/authentication'
import agent from './modules/agent'
import getPlugins from './getPlugins'
import mutationTypes from './mutation-types'

Vue.use(Vuex)
Vue.use(VueCookies)

const state = {
  lastVisit: moment().format('YYYY-MM-DD'),
}

export const mutations = {
  // we can use the ES2015 computed property name feature
  // to use a constant as the function name
  // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Object_initializer#New_notations_in_ECMAScript_2015
  // [SOME_MUTATION] (state) {
  //   // mutate state
  // }

  // lastVisit
  [mutationTypes.lastVisit] (state, payload) { // eslint-disable-line no-shadow
    state.lastVisit = payload // eslint-disable-line no-param-reassign
  },
}

const actions = {
  repairState({ commit }) {
    commit('repairNewContractState')
  },

  resetState({ commit }) {
    commit('resetNewContractState')
  },

  resetContractState({ commit }) {
    commit('resetNewContractState')
  },
}

const store = new Vuex.Store({
  strict: ENV.enableDebug,
  state,
  mutations,
  actions,
  modules: {
    newContract,
    authentication,
    agent,
  },
  plugins: getPlugins(),
})

store.dispatch('repairState')
window.__store = store // eslint-disable-line no-underscore-dangle

export default store
